var map = {
	"./Product.data": 3407,
	"./Product.data.js": 3407,
	"./Products": 258,
	"./Products.css": 3817,
	"./Products.js": 258,
	"./assets/883afd607c31d38d4b0702d700286be7.png": 1717,
	"./assets/9ff14aaa7dd2d865de0e46cbdf9b7953.png": 3009,
	"./assets/Asus-ROG-Phone-6-Ultimate.png": 699,
	"./assets/Google-Pixel-8-Pro.png": 8925,
	"./assets/Huawei-P50-Pro-Plus.png": 8114,
	"./assets/LG-Velvet-Plus.png": 1261,
	"./assets/Nokia-X30-5G-TA-1450.png": 1414,
	"./assets/OnePlus-10-Pro.png": 6154,
	"./assets/Samsung-Galaxy-S21-Ultra.png": 8053,
	"./assets/Samsung-Galaxy-S24-Ultra.png": 432,
	"./assets/Sony-Xperia-XZ5-Premium.png": 9845,
	"./assets/Xiaomi-Mi-12-Ultra.png": 1501,
	"./assets/iPhone-12.png": 5961,
	"./assets/iPhone-15-Pro-Max.png": 4281,
	"./assets/icon/smart..png": 4477,
	"./assets/icon/smartIcon.png": 8232,
	"./assets/icon/smartLogo.png": 9110,
	"./assets/shopping (1).webp": 3338,
	"./assets/shopping (2).webp": 7529,
	"./assets/shopping (3).webp": 9072,
	"./assets/shopping (4).webp": 2479,
	"./assets/shopping (5).webp": 5550,
	"./assets/shopping (6).webp": 5101,
	"./assets/shopping (7).webp": 2532,
	"./assets/shopping.webp": 8072,
	"./nav": 880,
	"./nav.css": 5450,
	"./nav.js": 880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8729;